import React, { FunctionComponent } from 'react';

import { Image } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';

import useMobile from 'src/shared/hooks/use-mobile';
import twAnnouncement from 'src/assets/images/tw/announcement.svg';

import styles from '../styles/tw-announcement-styles.module.scss';
import { AnnouncementStorageKeys, TW_ANNOUNCEMENT_URL } from '../constants';

export const TwBannerComponent: FunctionComponent = () => {
    const mobile = useMobile();
    const [modalSeen] = useLocalStorage({
        key: AnnouncementStorageKeys.modal,
        defaultValue: false,
    });

    if (!modalSeen || mobile) return null;

    return (
        <Image
            className={styles.banner}
            src={twAnnouncement}
            onClick={() => window.open(TW_ANNOUNCEMENT_URL, '_blank')}
        />
    );
};
